import { render, staticRenderFns } from "./HeaderHelpCenterButton.vue?vue&type=template&id=a588e336&scoped=true"
import script from "./HeaderHelpCenterButton.vue?vue&type=script&lang=js"
export * from "./HeaderHelpCenterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a588e336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a588e336')) {
      api.createRecord('a588e336', component.options)
    } else {
      api.reload('a588e336', component.options)
    }
    module.hot.accept("./HeaderHelpCenterButton.vue?vue&type=template&id=a588e336&scoped=true", function () {
      api.rerender('a588e336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderHelpCenterButton.vue"
export default component.exports